export const UPCOMING_EXCLUDED_STATUSES = new Set(["created", "completed"]);

export const isUpcomingOrder = (order = {}) => {
  const status = String(order?.status || "").trim().toLowerCase();

  if (!status) return false;
  if (UPCOMING_EXCLUDED_STATUSES.has(status)) return false;

  const orderDateValue = order?.inStockDate;
  if (!orderDateValue) return false;

  const orderDate = new Date(orderDateValue);
  if (Number.isNaN(orderDate.getTime())) return false;

  return orderDate > new Date();
};

